{
  "login": {
    "welcomeBackTitle": "Bon retour.",
    "tagline": "Toutes les enchères. En un seul toucher.",
    "emailLabel": "Courriel",
    "requiredHint": "Requis",
    "passwordLabel": "Mot de passe",
    "showPassword": "Afficher",
    "hidePassword": "Masquer",
    "signInButton": "Se connecter",
    "signingInButton": "Connexion…",
    "orContinueWith": "ou continuer avec",
    "newHerePrompt": "Nouveau ici?",
    "createAccountLink": "Créer un compte",
    "missingDetailsTitle": "Renseignements manquants",
    "missingDetailsMessage": "Saisissez votre courriel et votre mot de passe pour continuer.",
    "pendingApprovalTitle": "Compte en attente d’approbation",
    "pendingApprovalMessage": "Votre compte de concessionnaire est en attente d’approbation. Nous vous enverrons un courriel dès qu’il sera approuvé.",
    "invalidCredentialsTitle": "Connexion impossible",
    "invalidCredentialsMessage": "Vérifiez votre courriel et votre mot de passe. Le verrouillage des majuscules peut jouer des tours.",
    "forgotPasswordAction": "Mot de passe oublié?",
    "passwordResetTitle": "Réinitialisation du mot de passe",
    "passwordResetMessage": "La réinitialisation autonome du mot de passe arrive bientôt. Communiquez avec l’administrateur de votre concessionnaire pour l’instant.",
    "noConnectionMessage": "Votre demande ne nous est pas parvenue. Vérifiez votre connexion et réessayez.",
    "socialSignInComingSoonMessage": "La connexion avec les réseaux sociaux arrive bientôt. Utilisez le courriel pour l’instant.",
    "emailPlaceholder": "vous{'@'}exemple.com",
    "signingInTitle": "Connexion en cours…",
    "signingInLede": "Redirection vers la page de connexion AutoAuction.com.",
    "failedTitle": "La connexion n'a pas abouti",
    "failedCancelled": "La connexion a été annulée avant d'aboutir. Réessayez quand vous serez prêt.",
    "failedExpired": "Cette étape de connexion a expiré. Réessayez pour en recommencer une.",
    "failedService": "Nous n'avons pas pu joindre le service de connexion. Attendez un moment et réessayez.",
    "failedGeneric": "Une erreur s'est produite pendant la connexion. Réessayez.",
    "retryButton": "Réessayer",
    "accountNotLinked": "Vous êtes connecté, mais aucun compte concessionnaire approuvé ne correspond encore à ce courriel."
  },
  "linking": {
    "notLinkedTitle": "Configurons votre compte",
    "notLinkedSignedInAs": "Vous vous êtes connecté avec {provider} en tant que",
    "notLinkedLede": "Cette connexion n'a pas encore de compte AutoAuction.com.",
    "connectExistingButton": "J'ai déjà un compte",
    "matchTitle": "Vous avez déjà un compte",
    "matchLede": "Associez cette connexion {provider} et vous pourrez utiliser l'une ou l'autre pour vous connecter la prochaine fois.",
    "connectContinueButton": "Associer et continuer",
    "sheetTitle": "Connectez-vous à votre compte existant",
    "sheetLede": "Nous vous amènerons à la page de connexion. Connectez-vous une fois avec la méthode que vous utilisez déjà, et nous associerons cette connexion {provider} à ce compte.",
    "sheetStep1": "Connectez-vous avec votre méthode existante",
    "sheetStep2": "Nous vérifions que c'est bien votre compte",
    "sheetStep3": "La prochaine fois, connectez-vous avec l'une ou l'autre",
    "sheetContinueButton": "Continuer vers la connexion",
    "sheetCancelButton": "Annuler",
    "createAccountButton": "Configurer mon compte",
    "notNowLink": "Pas maintenant — se déconnecter",
    "restorableTitle": "Bon retour",
    "restorableLede": "Cette connexion appartenait à un compte fermé. Vous pouvez le restaurer — tout est encore là — ou repartir à neuf.",
    "restoreButton": "Restaurer mon compte",
    "startFreshButton": "Repartir à neuf avec un nouveau compte",
    "welcomeTitle": "Bienvenue sur AutoAuction.com, {name}",
    "welcomeLede": "Votre compte est prêt. L'accès aux enchères est accordé par votre concessionnaire ou votre maison d'enchères — demandez-leur une invitation; elle arrivera sur ce compte.",
    "welcomeButton": "Accéder à mon compte",
    "pageTitle": "Connexion et sécurité",
    "connectionsTitle": "Vos méthodes de connexion",
    "connectedOn": "Ajoutée le {date}",
    "unlinkButton": "Dissocier",
    "unlinkLastHint": "C'est votre seule méthode de connexion — ajoutez-en une autre avant de la retirer.",
    "unlinkConfirm": "Retirer cette méthode de connexion? Vous pourrez la rajouter plus tard.",
    "addLoginButton": "Ajouter une connexion",
    "addLoginTitle": "Choisissez une connexion à ajouter",
    "addLoginHint": "Vous vous connecterez une fois avec celle-ci pour prouver qu'elle est à vous.",
    "providerLocal": "Courriel et mot de passe",
    "linkedTitle": "Connexion associée",
    "linkedLede": "Vous pouvez désormais l'utiliser pour vous connecter.",
    "linkRefusedTitle": "Cette connexion n'a pas été associée",
    "linkRefusedLede": "Impossible d'associer cette connexion : {reason}",
    "linkOutcomeBackButton": "Retour à Connexion et sécurité",
    "closeTitle": "Fermer mon compte",
    "closeRow": "Fermer mon compte",
    "closeLede": "Fermer votre compte vous déconnecte partout et retire vos coordonnées de nos dossiers. Vos enchères et ventes passées restent dans les registres. Vous pourrez restaurer votre compte à tout moment en vous connectant avec l'une de vos anciennes méthodes.",
    "closeConfirmButton": "Fermer mon compte",
    "closeFinalConfirm": "Fermer votre compte maintenant?",
    "closeCancelButton": "Garder mon compte",
    "errorGeneric": "Une erreur s'est produite. Réessayez.",
    "connectionInUse": "Cette connexion est déjà associée à un autre compte.",
    "signedInAs": "Connecté en tant que",
    "backToAppButton": "Retour à l’application"
  },
  "profile": {
    "title": "Profil",
    "photoHint": "Le téléversement de photo arrivera avec le processus de vérification.",
    "identityTitle": "Identité",
    "nameLabel": "Nom",
    "namePlaceholder": "Votre nom",
    "primaryEmailLabel": "Courriel principal",
    "primaryEmailHint": "Choisissez parmi les adresses que vos connexions ont vérifiées.",
    "primaryEmailOnlyOne": "Ajoutez une connexion dans Connexion et sécurité pour choisir une autre adresse.",
    "phoneLabel": "Téléphone",
    "discardButton": "Abandonner",
    "savingButton": "Enregistrement…",
    "saveChangesButton": "Enregistrer les modifications",
    "requiredError": "Obligatoire",
    "saved": "Profil enregistré.",
    "saveFailed": "Impossible d’enregistrer — réessayez.",
    "backButton": "Retour"
  },
  "sessions": {
    "title": "Sessions actives",
    "lede": "Où vous êtes connecté en ce moment.",
    "thisDevice": "Cet appareil",
    "browserOnSystem": "{browser} sur {system}",
    "unknownBrowser": "Navigateur inconnu",
    "unknownSystem": "un système inconnu",
    "signedInWith": "Connecté avec {method}",
    "signedInAt": "Connecté le {date}",
    "lastActive": "Dernière activité {date}",
    "ipAddress": "Adresse IP {address}",
    "signOutButton": "Déconnecter",
    "signOutTitle": "Déconnecter cet appareil?",
    "signOutMessage": "{device} sera déconnecté. Pour vous y reconnecter, il faudra votre mot de passe ou votre identifiant.",
    "signOutConfirm": "Déconnecter",
    "everywhereButton": "Me déconnecter partout",
    "everywhereTitle": "Vous déconnecter partout?",
    "everywhereMessage": "Tous les appareils où vous êtes connecté seront déconnectés, y compris celui-ci. Chacun demandera votre mot de passe ou votre identifiant pour vous reconnecter.",
    "everywhereConfirm": "Me déconnecter partout",
    "cancel": "Annuler",
    "failed": "Cela n'a pas fonctionné; rien n'a été déconnecté. Réessayez.",
    "loadFailed": "Impossible de charger vos sessions.",
    "apps": {
      "mobile-vibe-portal": "Application AutoAuction.com",
      "desktop-vibe-portal": "AutoAuction.com Administration"
    }
  },
  "mfa": {
    "title": "Connexion en deux étapes",
    "lede": "Lorsqu'elle est activée, la connexion avec votre courriel et votre mot de passe demande aussi un code à 6 chiffres d'une application d'authentification sur votre téléphone.",
    "statusOn": "Activée",
    "statusOff": "Désactivée",
    "notAvailable": "Vous êtes connecté avec Google ou Microsoft, dont la connexion en deux étapes protège déjà ce compte. Pour configurer un code pour votre courriel et votre mot de passe, connectez-vous avec ceux-ci.",
    "turnOnButton": "Activer",
    "turnOffButton": "Désactiver",
    "setupTitle": "Configurez votre application d'authentification",
    "scanStep": "Numérisez ce code avec une application d'authentification, comme Google Authenticator, 1Password ou Authy.",
    "scanAlt": "Le code à numériser avec votre application d'authentification",
    "enterByHand": "Ou saisissez cette clé dans l'application :",
    "codeLabel": "Les 6 chiffres affichés par l'application",
    "lostWarning": "Gardez l'application en lieu sûr. Si vous la perdez, vous ne pourrez plus vous connecter avec votre courriel et votre mot de passe.",
    "confirmButton": "Activer la connexion en deux étapes",
    "cancelButton": "Annuler",
    "turnOffTitle": "Désactiver la connexion en deux étapes?",
    "turnOffMessage": "On ne vous demandera plus de code lorsque vous vous connecterez avec votre courriel et votre mot de passe.",
    "turnOffConfirm": "Désactiver",
    "wrongCode": "Ce code n'est pas le bon. Attendez que l'application en affiche un nouveau et réessayez.",
    "signInAgain": "Connectez-vous de nouveau avec votre courriel et votre mot de passe, puis revenez ici.",
    "failed": "Cela n'a pas fonctionné. Réessayez.",
    "loadFailed": "Vos paramètres de connexion en deux étapes n'ont pas pu être chargés."
  }
}
